import { createContext, useContext, useReducer } from "react";
import { reducer } from "../reducer/reducer";
import {
  brandCategory,
  ratingCategory,
  priceRangeCategory,
} from "../utilities/filteroperations";
import { useProductsData } from "./product-context";

const useFilteredData = (state) => {
  let { productData } = useProductsData();

  // getting selected keys
  const brandCategories = Object.keys(state.brand).filter(
    (key) => state.brand[key]
  );

  if (brandCategories.length > 0) {
    productData = brandCategory(productData, brandCategories);
  }

  //ratings categories
  const ratingsCategories = Object.keys(state.ratings).filter(
    (key) => state.ratings[key]
  );
  if (ratingsCategories.length > 0) {
    productData = ratingCategory(productData, ratingsCategories);
  }

  // price range categories
  const priceRangeCategories = Object.keys(state.priceRange).filter(
    (key) => state.priceRange[key]
  );

  if (priceRangeCategories.length > 0) {
    productData = priceRangeCategory(productData, priceRangeCategories);
  }

  return productData;
};

const DataContext = createContext();

const DataProvider = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, {
    wishlist: [],
    brand: {
      smartphones: false,
      laptops: false,
    },
    priceRange: {
      under500: false,
      price1000To3000: false,
    },
    ratings: {
      star5: false,
      star4: false,
      star3: false,
      star2: false,
      star1: false,
    },
  });

  return (
    <DataContext.Provider
      value={{
        state,
        dispatch,
        data: useFilteredData(state),
      }}
    >
      {children}
    </DataContext.Provider>
  );
};

const useData = () => useContext(DataContext);

export { useData, DataProvider };
